import Fetch from 'utils/fetch'

export const getUnloadCapacities = (businessUnitId) => {
  return Fetch.get(`/unload-capacities:by-business-unit-id?businessUnitId=${businessUnitId}`).then(({ data }) => data)
}

export const getLoadCapacities = (businessUnitId) => {
  return Fetch.get(`/load-capacities:by-business-unit-id?businessUnitId=${businessUnitId}`).then(({ data }) => data)
}

export const saveUnloadCapacity = (request) => {
  return Fetch.post(`/unload-capacities`, request)
}

export const saveLoadCapacity = (request) => {
  return Fetch.post(`/load-capacities`, request)
}